// api
// export const serviceCategoryList = serviceCategory + '/list'
export const apiStore = '/store'
// export const serviceCategoryUpdate = serviceCategory + '/update'
// export const serviceCategoryToggleStatus = serviceCategory + '/toggle-status'
// export const serviceCategoryDestroy = serviceCategory + '/destroy'
